<div class="kt-portlet__body">
    <div class="row align-items-center">
        <div class="col-12 d-flex align-items-center">
            <div class="col">
                <div class="form-group">
                    <label for="SearchString">
                        <span translation="{{searchLabel}}" source="Axilla"></span> *
                    </label>
                    <input type="text"
                           name="SearchString"
                           class="form-control"
                           [(ngModel)]="searchString"
                           (input)="onSearching()"
                           maxlength="64">
                </div>
            </div>

            <button style="height: 38px" type="button" class="btn btn-primary" (click)="clear()">
                <span translation="Clear" source=""></span>
            </button>
        </div>
    </div>

        <div class="row align-items-center position-relative">
            <div class="col primeng-datatable-container">
                <p-table #dataTable
                         [value]="primengTableHelper.records"
                         [columns]="cols"
                         rows="{{primengTableHelper.defaultRecordsCountPerPage}}"
                         [paginator]="false"
                         [lazy]="true"
                         (onLazyLoad)="onPageChange($event)"
                         [(selection)]="itemsSelected"
                         (onRowSelect)="onRowSelection($event)"
                         (onRowUnselect)="onRowUnSelection($event)"
                         [responsive]="primengTableHelper.isResponsive">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th style="width: 3em">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </th>
                            <ng-container *ngFor="let col of columns">
                                <th *ngIf="!col.sorting"
                                    [style.width]="col.width ? col.width : 'auto'">
                                    <span translation="{{col.header}}" source="Axilla"></span>
                                </th>

                                <th *ngIf="col.sorting"
                                    [style.width]="col.width ? col.width : 'auto'" pSortableColumn="{{col.field}}">
                                    <span translation="{{col.header}}" source="Axilla"></span>
                                    <p-sortIcon field="{{col.field}}"></p-sortIcon>
                                </th>
                            </ng-container>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr>
                            <td>
                                <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                            </td>
                            <td *ngFor="let col of columns">
                                <ng-container [ngSwitch]="col.type">
                                    <div *ngSwitchCase="3">
                                        {{rowData[col.field] | momentFormat:'dd-MM-YYYY'}}
                                    </div>
                                    <div *ngSwitchCase="4">
                                        {{rowData[col.field] | momentFormat:'DD-mm-yyyy, HH:mm'}}
                                    </div>
                                    <div *ngSwitchCase="10">
                                        <app-image-container [articleId]="rowData[col.field]" [height]="col.height"></app-image-container>
                                    </div>
                                    <div *ngSwitchDefault>
                                        {{rowData[col.field]}}
                                    </div>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                    <span translation="NoData"></span>
                </div>
                <div class="primeng-paging-container">
                    <p-paginator [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                 #paginator
                                 (onPageChange)="onPageChange($event)"
                                 [totalRecords]="primengTableHelper.totalRecordsCount"
                                 [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage">
                    </p-paginator>
                    <span class="total-records-count">
                        {{'TotalRecordsCount' | localize:primengTableHelper.totalRecordsCount}}
                    </span>
                </div>
                <div class="spinner-container" *ngIf="primengTableHelper.isLoading">
                    <p-progressSpinner></p-progressSpinner>
                </div>
            </div>
            <!--<div class="spinner-container" *ngIf="primengTableHelper.isLoading">
                <p-progressSpinner></p-progressSpinner>
            </div>-->
        </div>
    </div>
